import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { CaseAssignmentPolicy } from 'dashboard/models/case-assignment-policy';
import { setCaseAssignmentPolicy } from 'dashboard/redux/slices/case-assignment-policy';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadCaseAssignmentPolicy(id: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data } = await SessionClientDashboard.getResource<CaseAssignmentPolicy>(
      ApiEndpoint.CaseAssignmentPolicy,
      id,
    );

    dispatch(setCaseAssignmentPolicy({ caseAssignmentPolicy: data }));
  };
}

export function updateCaseAssignmentPolicy(
  id: string,
  caseAssignmentPolicy: CaseAssignmentPolicy,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data } = await SessionClientDashboard.updateResource<CaseAssignmentPolicy>({
      type: ApiModel.CaseAssignmentPolicy,
      id,
      attributes: {
        ...caseAssignmentPolicy.attributes,
      },
    });

    dispatch(setCaseAssignmentPolicy({ caseAssignmentPolicy: data }));
  };
}
